import { createContext, useContext } from 'react'

import { NodeOutputOption } from '@/shared/action.types'

export const ConditionSelectContext = createContext<{
  id?: string
  open: boolean
  setOpen: (next: boolean) => void
  index: number
  isRhs: boolean
  isEnd: boolean
  focused: {
    lhs: boolean
    rhs: boolean
  }
  setFocused: (
    next: Partial<{
      lhs: boolean
      rhs: boolean
    }>
  ) => void
  inputRef: React.RefObject<HTMLInputElement>
  rhsInputRef: React.RefObject<HTMLInputElement>
  actions?: NodeOutputOption[]
} | null>(null)

export function useConditionSelectContext() {
  const context = useContext(ConditionSelectContext)
  if (!context) {
    throw new Error('useConditionSelectContext must be used within a ConditionSelectContext.Provider')
  }
  return context
}
